import { HttpService } from 'src/app/services/http-wrapper.service';
import { ErrorMessageComponent } from 'src/app/shared/error-message/error-message.component';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-facilities',
  templateUrl: './facilities.component.html',
  styleUrls: ['./facilities.component.css']
})
export class FacilitiesComponent implements OnInit {
  @ViewChild(ErrorMessageComponent)

  public errorComponent!: ErrorMessageComponent;
  facilitiesData: any;
  modalRef!: BsModalRef;
  selectedUserGroup!:string;
  constructor(private modalService: BsModalService,public httpService: HttpService,) { }

  ngOnInit(): void {
    this.httpService.startCallGroup(1, "Add Users");
    this.loadConfiguration();
  }
  loadConfiguration() {
    this.httpService.get("assets/forms.json", this.errorComponent)
      .subscribe((dummyData) => {
        this.facilitiesData = dummyData;
      });
  }
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {
      animated: true,
      backdrop: 'static'
    });
  }

}
